import ConfirmationDialog from '@rio-cloud/rio-uikit/ConfirmationDialog';
import ClearableInput from '@rio-cloud/rio-uikit/ClearableInput';
import { useState } from 'react';
import type React from 'react';
import type { FreeTrialState } from '../api/freetrial/types';
import { useUpdateFreeTrialEligibilityAction } from './useUpdateFreeTrialEligibilityAction';

type FreeTrialEligibilityDialogProps = {
    show: boolean;
    freeTrialState: FreeTrialState;
    statusLabel: React.ReactNode;
    onClose: () => void;
};

export function FreeTrialEligibilityDialog(props: FreeTrialEligibilityDialogProps) {
    const { show, freeTrialState, statusLabel, onClose } = props;
    const [eligibleReason, setEligibleReason] = useState('');
    const { updateFreeTrialEligibility, isLoading: isSubmitting } = useUpdateFreeTrialEligibilityAction();

    const resetDialog = () => {
        setEligibleReason('');
    };

    const handleClose = () => {
        resetDialog();
        onClose();
    };

    const handleConfirmMakeEligible = async () => {
        if (!freeTrialState || eligibleReason.trim() === '') {
            return;
        }

        const wasSuccessful = await updateFreeTrialEligibility({
            accountId: freeTrialState.accountId,
            status: 'eligible',
            reason: eligibleReason.trim(),
        });

        if (wasSuccessful) {
            handleClose();
        }
    };

    return (
        <ConfirmationDialog
            show={show}
            title='Confirm action'
            content={
                <div>
                    <p>Are you sure you want to make this account eligible for free trial?</p>
                    <table className='table table-hover table-head-filled table-bordered'>
                        <thead>
                            <tr>
                                <th>AccountId</th>
                                <th>Name</th>
                                <th>Free Trial Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{freeTrialState.accountId}</td>
                                <td>{freeTrialState.accountName}</td>
                                <td>{statusLabel}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div className='form-group margin-bottom-10'>
                        <label htmlFor='freeTrialEligibleReason'>
                            <h5>Reason or ticket number*</h5>
                        </label>
                        <ClearableInput
                            id='freeTrialEligibleReason'
                            value={eligibleReason}
                            onChange={(newValue: string) => setEligibleReason(newValue)}
                            placeholder='Enter reason or ticket number'
                        />
                    </div>
                </div>
            }
            cancelButtonText='Cancel'
            confirmButtonText={isSubmitting ? 'Confirming...' : 'Confirm'}
            disableConfirm={eligibleReason.trim() === ''}
            onClickCancel={handleClose}
            onClickConfirm={handleConfirmMakeEligible}
        />
    );
}
